/**
 * EnhancedInputData model
 */

export class EnhancedInputData {
    BackgroundColor: string = "None";
    TextColor: string = "Black";
    TextFont: string = "Times New Roman Bold";
    Imagename: string = "";
    bUseEnhancedGraphics: boolean = true;
    bAllowCancel: boolean = true;
    NewImage: string = "";
}

export function SetupEnhInputData(GameData: any[]): EnhancedInputData {
    const CurData = new EnhancedInputData();
    CurData.BackgroundColor = GameData[0];
    CurData.TextColor = GameData[1];
    CurData.Imagename = GameData[2];
    CurData.bUseEnhancedGraphics = GameData[3];
    CurData.bAllowCancel = GameData[4];
    CurData.NewImage = GameData[5];
    CurData.TextFont = GameData[6];
    return CurData;
}
